export default class TyreHotelWheelSetHistoryWheel {
  public id: number
  public placement: string
  public tyreBrand: string
  public tyreModel: string
  public rimMaterialType: string
  public rimBrand: string
  public rimModel: string
  public dimension: string
  public hasBolts: boolean
  public isRunFlat: boolean
  public isCTyre: boolean
  public hasTyreDamages: boolean
  public hasRimDamages: boolean
  public comment: string
  public treadDepth: number
  public airPressure: number
  public isStudded: boolean
  public hasHubCaps: boolean
  public hasWheelLock: boolean
  public hasNitrogen: boolean
  public hasTpms: boolean
  public tpmsType: string
  public tpmsBatteryLevel: number
  public dotMark: string

  public tyreHotelWheelSetHistoryId: number
  public positionId: number
  public positionName: string

  public constructor(data: Record<string, unknown> = null) {
    if (!data) {
      data = {}
    }
    this.id = data.id ? (data.id as number) : null
    this.placement = data.placement ? (data.placement as string) : null
    this.tyreBrand = data.tyreBrand ? (data.tyreBrand as string) : null
    this.tyreModel = data.tyreModel ? (data.tyreModel as string) : null
    this.rimMaterialType = data.rimMaterialType ? (data.rimMaterialType as string) : null
    this.rimBrand = data.rimBrand ? (data.rimBrand as string) : null
    this.rimModel = data.rimModel ? (data.rimModel as string) : null
    this.dimension = data.dimension ? (data.dimension as string) : null
    this.hasBolts = data.hasBolts ? (data.hasBolts as boolean) : null
    this.isRunFlat = data.isRunFlat ? (data.isRunFlat as boolean) : null
    this.isCTyre = data.isCTyre ? (data.isCTyre as boolean) : null
    this.hasTyreDamages = data.hasTyreDamages ? (data.hasTyreDamages as boolean) : null
    this.hasRimDamages = data.hasRimDamages ? (data.hasRimDamages as boolean) : null
    this.comment = data.comment ? (data.comment as string) : null
    this.treadDepth = data.treadDepth ? (data.treadDepth as number) : null
    this.airPressure = data.airPressure ? (data.airPressure as number) : null
    this.isStudded = data.isStudded ? (data.isStudded as boolean) : null
    this.hasHubCaps = data.hasHubCaps ? (data.hasHubCaps as boolean) : null
    this.hasWheelLock = data.hasWheelLock ? (data.hasWheelLock as boolean) : null
    this.hasNitrogen = data.hasNitrogen ? (data.hasNitrogen as boolean) : null
    this.hasTpms = data.hasTpms ? (data.hasTpms as boolean) : null
    this.tpmsType = data.tpmsType ? (data.tpmsType as string) : null
    this.tpmsBatteryLevel = data.tpmsBatteryLevel ? (data.tpmsBatteryLevel as number) : null
    this.dotMark = data.dotMark ? (data.dotMark as string) : null

    this.tyreHotelWheelSetHistoryId = data.tyreHotelWheelSetHistoryId
      ? (data.tyreHotelWheelSetHistoryId as number)
      : null
    this.positionId = data.positionId ? (data.positionId as number) : null
    this.positionName = data.positionName ? (data.positionName as string) : null
  }

  public clone(): TyreHotelWheelSetHistoryWheel {
    const result = new TyreHotelWheelSetHistoryWheel()
    Object.assign(result, this)
    return result
  }

  public getShortPlacementForTranslation(): string {
    const shortPlacement = this.placement ? this.placement.replace(/[^A-Z]+/g, '') : '?'
    return 'c:tyre-hotel-placement-short:' + shortPlacement
  }
}
